import { lazy, Suspense } from "react";
import styled from "styled-components";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import theme from './theme/schema.js';
import { GlobalStyles } from "./theme/globalStyles";
import PageLoader from "./components/pageLoader";
import Header from "./components/header";

const Calculator = lazy(() => import("./pages/calculator"));
const Results = lazy(() => import("./pages/results"));


const Wrapper = styled.div`
  min-height: 100vh;
  position: relative;
`;
const HeaderContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto; 
  padding-top: 20px;
  padding-right: 10px;
  padding-left: 10px;

`;


export function AppWrapper() {
  return (
    <Router>
      <Switch>
        <Suspense fallback={<PageLoader />}>
          <App />
        </Suspense>
      </Switch>
    </Router>
  )
}


// App component
export function App() {

  const query = new URLSearchParams(window.location.search);
  const country = query.get("country");
  const lang = query.get("lang");
  const step = query.get("step");
  const page = query.get("page");


  const printSwitch = () => {

    if((country !== null && country !== "") && (lang !== null && lang !== "") && (page !== null && page !== "" && page === "results")) {

      return (
        <>
          {/* <Route path="/"><Redirect to={`/${country}/${lang}/results`} /></Route>
          <Route exact path="/:country/:lang/results"><Results /></Route> */}
          
          {/* <Route path={`/`}><Results /></Route> */}
          
          <Results />
        </>
      )

    } else if((country !== null && country !== "") && (lang !== null && lang !== "") && (step !== null && step !== "")) {


      return (
        <>
          {/* <Route path="/"><Redirect to={`/${country}/${lang}?step=${step}`} /></Route>
          <Route exact path="/:country/:lang"><Calculator /></Route> */}
          
          {/* <Route path={`/`}><Calculator /></Route> */}
          
          <Calculator />
        </>
      )

    } else if((country !== null && country !== "") && (lang !== null && lang !== "")) {

      return (
        <>
          {/* <Route path="/"><Redirect to={`/${country}/${lang}`} /></Route>
          <Route exact path="/:country/:lang"><Calculator /></Route> */}
          
          {/* <Route path={`/`}><Calculator /></Route> */}
          
          <Calculator />
        </>
      )

    } else {

      return (
        <>
          {/* <Route exact path="/"><Redirect to="/uk/en" /></Route>
          <Route exact path="/:country"><Redirect to="/uk/en" /></Route>
          <Route exact path="/:country/:lang"><Calculator /></Route>
          <Route exact path="/:country/:lang/results"><Results /></Route> */}

          {/* <Route path={`/`}><Calculator /></Route> */}

          <Calculator />
        </>
      )

    }
  }


  return (
    <ThemeProvider theme={theme}>
          <GlobalStyles/>
          <Wrapper>
          
            <HeaderContainer>
              <Header />
            </HeaderContainer>

            {printSwitch()}

          </Wrapper>
    </ThemeProvider>
  );
}